// extracted by mini-css-extract-plugin
export default {"root":"ChooseActionsLabel_root__9aFoS"};